"use client";

interface UserStatusConfirmModalProps {
  mode: "activate" | "deactivate";
  userName: string;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

const UserStatusConfirmModal: React.FC<UserStatusConfirmModalProps> = ({
  mode,
  userName,
  onCancel,
  onConfirm,
  isProcessing = false,
}) => {
  const isDeactivate = mode === "deactivate";
  const title = isDeactivate ? "Ngưng hoạt động" : "Kích hoạt";
  const description = isDeactivate
    ? `Bạn có chắc muốn ngưng người dùng "${userName}"?`
    : `Bạn có chắc muốn kích hoạt người dùng "${userName}"?`;
  const confirmLabel = isDeactivate ? "Ngưng ngay" : "Kích hoạt";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="mt-3 text-sm text-slate-600">{description}</p>

        <div className="mt-6 flex justify-end gap-3">
          <button onClick={onCancel} disabled={isProcessing} className="rounded-full border px-4 py-2">Hủy</button>
          <button
            onClick={onConfirm}
            disabled={isProcessing}
            className={`rounded-full px-4 py-2 text-white ${
              isDeactivate ? "bg-amber-500 hover:bg-amber-600" : "bg-emerald-600 hover:bg-emerald-700"
            } disabled:opacity-60`}
          >
            {isProcessing ? "Đang xử lý..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserStatusConfirmModal;
